/**
 * @pageName BookingCalendar
 * @slotType site plugin
 */
export interface AvailabilitySlotPluginApi {
  availabilityPreferences: AvailabilityPreferences;
}

/** @internal */
export interface AvailabilityPreferences {
  fromLocaleDate: string;
  toLocaleDate: string;
  timezone: string;
  locations: {
    id?: string;
    locationType: LocationType;
  }[];
  services: {
    serviceId: string;
    serviceType: ServiceType;
    resourceTypes: {
      resourceTypeId: string;
      resourceIds: string[];
    }[];
  }[];
}

/** @internal */
export enum LocationType {
  UNKNOWN_LOCATION_TYPE = 'UNKNOWN_LOCATION_TYPE',
  /**
   * Location set by the business that is not a standard business [location](https://dev.wix.com/docs/rest/business-management/locations/introduction).
   */
  CUSTOM = 'CUSTOM',
  /**
   * Business [location](https://dev.wix.com/docs/rest/business-management/locations/introduction).
   */
  BUSINESS = 'BUSINESS',
  /**
   * The customer specifies any address when booking. Available only for
   * appointment-based services.
   */
  CUSTOMER = 'CUSTOMER',
}

/** @internal */
export enum ServiceType {
  UNKNOWN_SERVICE_TYPE = 'UNKNOWN_SERVICE_TYPE',
  /** Appointment-based service. */
  APPOINTMENT = 'APPOINTMENT',
  /** Class service. */
  CLASS = 'CLASS',
  /** Course service. */
  COURSE = 'COURSE',
}
export const SlotIds = {
  calendarAvailabilitySlot: '74c4c90d-39a4-4ee4-bfd3-a025857db32a',
};
